import { Link } from 'react-router-dom'
import { Facebook, Instagram, Youtube, Linkedin, Mail, Phone, MapPin } from 'lucide-react'
import { useSiteConfig } from '../../context/SiteConfigContext'
import { useTranslation } from 'react-i18next'

function Footer() {
  const { siteConfig } = useSiteConfig()
  const { t } = useTranslation()

  return (
    <footer className="bg-neutral-800 text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img src="/logo-genika.png" alt="Génika - Salud a tu Domicilio" className="h-10 w-auto brightness-0 invert" />
            </div>
            <p className="text-neutral-400 mb-4">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              {siteConfig.facebookUrl && (
                <a href={siteConfig.facebookUrl} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  <Facebook className="h-5 w-5" />
                </a>
              )}
              {siteConfig.instagramUrl && (
                <a href={siteConfig.instagramUrl} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  <Instagram className="h-5 w-5" />
                </a>
              )}
              {siteConfig.youtubeUrl && (
                <a href={siteConfig.youtubeUrl} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  <Youtube className="h-5 w-5" />
                </a>
              )}
              {siteConfig.linkedinUrl && (
                <a href={siteConfig.linkedinUrl} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  <Linkedin className="h-5 w-5" />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              {[
                { key: 'about', href: '/about', label: t('footer.links.about') },
                { key: 'services', href: '/services', label: t('footer.links.services') },
                { key: 'team', href: '/team', label: t('footer.links.team') },
                { key: 'blog', href: '/blog', label: t('footer.links.blog') },
                { key: 'store', href: '/store', label: t('footer.links.store') },
                { key: 'downloads', href: '/downloads', label: t('footer.links.downloads') },
              ]
                .filter(item => (siteConfig.navItems || {})[item.key] !== false)
                .map(item => (
                  <li key={item.key}>
                    <Link to={item.href} className="text-neutral-400 hover:text-primary-500 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.services')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  {t('footer.servicesList.hospitalization')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  {t('footer.servicesList.consultations')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  {t('footer.servicesList.nursing')}
                </Link>
              </li>
              {/* <li>
                <Link to="/coverage" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  {t('footer.servicesList.coverage')}
                </Link>
              </li> */}
              <li>
                <Link to="/faq" className="text-neutral-400 hover:text-primary-500 transition-colors">
                  {t('footer.servicesList.faq')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-primary-500 mt-1 flex-shrink-0" />
                <span className="text-neutral-400">{siteConfig.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-primary-500 flex-shrink-0" />
                <span className="text-neutral-400">{siteConfig.phone}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-primary-500 flex-shrink-0" />
                <span className="text-neutral-400">{siteConfig.email}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-700 mt-8 pt-8 flex flex-col items-center gap-3 md:flex-row md:justify-between">
          <p className="text-neutral-400 text-sm">
            {t('footer.copyright')}
          </p>
          <p className="text-neutral-500 text-sm tracking-wide">
            {t('footer.poweredBy')}{' '}
            <span className="text-neutral-400 font-semibold hover:text-primary-500 transition-colors cursor-default">
              Frylo
            </span>
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-neutral-400 hover:text-primary-500 text-sm transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="text-neutral-400 hover:text-primary-500 text-sm transition-colors">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer